import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Params } from "@angular/router";
import { AppConstants } from "@core/constants/app";

@Component({
    selector: "app-plan-item",
    templateUrl: "./plan-item.component.html",
    styleUrls: ["./plan-item.component.scss"],
    standalone: false,
})
export class PlanItemComponent {
    protected readonly AppConstants = AppConstants;
    @Input() plan: Params = {};
    @Input() options: Params = [];
    @Input() selected = false;
    @Input() showDisclaimers = false;
    @Output() openBenefitsModalBtnClicked = new EventEmitter();
    @Output() openDownloadsModalBtnClicked = new EventEmitter();
    @Output() openBenefitsSelectionModalBtnClicked = new EventEmitter();
    @Output() planSelected = new EventEmitter();

    constructor() {}

    get premiumLabelKey(): string {
        switch (this.plan?.id) {
            case AppConstants.PlanId.IBP:
                return "common.planItem.partD";
            case AppConstants.PlanId.SGH:
            case AppConstants.PlanId.SGH2:
                return "common.planItem.partC";
            default:
                return "common.planItem.perMonth.2027";
        }
    }

    showBenefitsModal() {
        this.openBenefitsModalBtnClicked.emit([...this.plan.benefits.col1, ...this.plan.benefits.col2]);
    }

    showDownloadsModal() {
        this.openDownloadsModalBtnClicked.emit(this.plan.assets);
    }

    emitSelectedPlanEvent(): void {
        if (Array.isArray(this.plan.additionalBenefits) && this.plan.additionalBenefits.length) {
            this.openBenefitsSelectionModalBtnClicked.emit(this.plan);
            return;
        }
        this.planSelected.emit({ id: this.plan.id, benefitOption: "000" });
    }
}
